import React from 'react';

// Components
import Tooltip from './Tooltip';

// Hooks
import useThemeVersion from '@/hooks/useThemeVersion';

// Libraries
import classNames from 'classnames';

// Types
import { tooltipPlacement } from '@/types/tooltip';

// Legacy
import LegacyWarningTooltip from './LegacyWarningTooltip';

type Props = {
  children?: React.ReactNode;
  className?: string;
  list?: Array<any>;
  message: string;
  place?: tooltipPlacement;
  title?: string;
};

const WarningTooltipV2 = ({ children, className, ...rest }: Props) => (
  <Tooltip className={classNames('custom-tooltip-v2 warning-tooltip tooltip-icon', className)} icon="icon-ds-warning" {...rest}>
    <span tabIndex={0}>{children || <i className="icon-ds-warning displayed-icon" />}</span>
  </Tooltip>
);

const WarningTooltip = (props: Props) => {
  const { isLightVersion } = useThemeVersion();
  if (isLightVersion) {
    return <WarningTooltipV2 {...props} />;
  }
  return <LegacyWarningTooltip {...props} />;
};

export default WarningTooltip;
